import { clamp } from "lodash-es";

import { MIN_VISIBLE_AREA_WIDTH, SVG_STYLES } from "../settings.ts";

export function getVisibleAreaBox(
  scale: number,
  panelHeight: number,
  panelWidth: number,
  canvasWidth: number,
  scrollX: number,
): { x: number; y: number; width: number; height: number } {
  const scaledCanvasWidth = canvasWidth * scale;
  const pixelPerfectOffset = (SVG_STYLES.visibleRegion.strokeWidth / 2) % 2;

  // width of region indicator. Stroke on the right needs to be considered inclusive here
  const width = Math.max(scaledCanvasWidth, MIN_VISIBLE_AREA_WIDTH);
  const height = panelHeight - SVG_STYLES.visibleRegion.strokeWidth;

  const scaledScrollX = scrollX * scale - (width - scaledCanvasWidth) / 2;
  const y = pixelPerfectOffset;

  // We don't round to prevent pixel jumps
  const x = clamp(scaledScrollX + pixelPerfectOffset, 0, panelWidth - width - pixelPerfectOffset);

  return { width, height, x, y };
}
